import { LangBadge } from "../shop/Flag";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, eur, errMsg } from "../../lib/api";
import { DICT } from "../../lib/i18n";

const STATUSES = ["paid", "shipped", "delivered", "cancelled"];

const OrderRow = ({ o, onSaved }) => {
  const [tracking, setTracking] = useState(o.tracking_number || "");
  const update = async (status) => {
    try { await api.patch(`/admin/orders/${o.id}`, { status, tracking_number: tracking }); toast.success("Bestellung aktualisiert"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="bg-white rounded-2xl border border-[#120E1F]/5 p-5 space-y-3" data-testid={`admin-order-${o.order_number}`}>
      <div className="flex flex-wrap justify-between gap-3">
        <div><p className="font-mono text-sm">{o.order_number}</p><p className="text-xs text-[#707783]">{new Date(o.created_at).toLocaleString("de-DE")} · {o.email} · {o.payment_method}</p></div>
        <span className={`badge-pill h-fit ${o.payment_status === "paid" ? "bg-emerald-50 text-emerald-700" : "bg-gray-100 text-gray-500"}`}>{o.payment_status}</span>
        <p className="font-mono font-semibold">{eur(o.total)}</p>
      </div>
      <ul className="text-sm space-y-1">{o.items.map((i) => <li key={i.product_id} className="flex flex-wrap items-center gap-2" data-testid={`admin-order-item-${i.sku || i.product_id}`}>{i.quantity}× {i.name}<LangBadge code={i.language} />{i.sku && <span className="text-[10px] font-mono text-[#707783]">SKU {i.sku}</span>}</li>)}</ul>
      <p className="text-xs text-[#707783]">{o.address?.name}, {o.address?.street}, {o.address?.zip} {o.address?.city}, {o.address?.country}</p>
      {o.payment_status === "paid" && (
        <div className="flex flex-wrap items-center gap-3 pt-2 border-t">
          <input value={tracking} onChange={(e) => setTracking(e.target.value)} placeholder="DHL Sendungsnummer" data-testid={`tracking-input-${o.order_number}`} className="rounded-lg border border-[#120E1F]/10 px-3 py-1.5 text-sm font-mono" />
          <select value={o.status} onChange={(e) => update(e.target.value)} data-testid={`order-status-select-${o.order_number}`} className="rounded-lg border border-[#120E1F]/10 px-3 py-1.5 text-sm">
            {STATUSES.map((s) => <option key={s} value={s}>{DICT.de.st[s]}</option>)}
          </select>
        </div>
      )}
    </div>
  );
};

export const OrdersPanel = () => {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("paid");
  const load = useCallback(() => api.get("/admin/orders", { params: { status: filter || undefined } }).then((r) => setOrders(r.data)), [filter]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        {[["paid", "Bezahlt"], ["", "Alle"]].map(([v, l]) => (
          <button key={l} onClick={() => setFilter(v)} data-testid={`orders-filter-${v || "all"}`} className={`px-4 py-1.5 rounded-full text-sm border ${filter === v ? "bg-[#120E1F] text-[#C9B6F2]" : "bg-white"}`}>{l}</button>
        ))}
      </div>
      {orders.length === 0 && <p className="text-[#707783] text-sm" data-testid="admin-no-orders">Keine Bestellungen.</p>}
      {orders.map((o) => <OrderRow key={o.id} o={o} onSaved={load} />)}
    </div>
  );
};
